import {
  isLocalDev,
  isRuntimeProduction,
  isRuntimeStaging
} from '@/utils/env';

export const isProduction = isRuntimeProduction();
export const isStaging = isRuntimeStaging();
export const isDEV = () => isLocalDev() || location.href.indexOf('gtm') > -1;
